import { useContext } from "react";
import {
  deleteTransaction,
  getTransactions,
} from "../../services/transactionService";
import { AuthContext } from "../Auth/AuthContext";
import { useGroupContext } from "../Groups/useGroupContext";
import { getCurrencySymbol } from "../utils/currencyFormatter";
import { formatDate } from "../utils/dateUtils";
import TransactionTable from "./TransactionTable";

const Expenses = () => {
  const { getContextParams } = useGroupContext();
  const { userCurrency } = useContext(AuthContext);

  return (
    <TransactionTable
      title="Your Expenses"
      transactionType="expense"
      fetchFunction={(type) => getTransactions(type, getContextParams())}
      deleteFunction={(id) => deleteTransaction(id, getContextParams())}
      editPath="/edit-expense"
      addPath="/add-transaction?type=EXPENSE"
      columns={[
        { id: "date", label: "Date", sortable: true, format: formatDate },
        { id: "vendor", label: "Vendor", sortable: true },
        {
          id: "amount",
          label: `Amount (${getCurrencySymbol(userCurrency)})`,
          sortable: true,
        },
        { id: "category_name", label: "Category", sortable: true },
        { id: "note", label: "Note", sortable: false },
        { id: "user_name", label: "User Name", sortable: true },
      ]}
      filterableFields={[{ id: "category_name", label: "category names" }]}
      defaultSortColumn="date"
      sortOrder="desc"
    />
  );
};

export default Expenses;
